import { createContext } from "react";

import { AirlineListItem } from "../AirlineListItem";

interface IAirlineContext {
    airlineItems: AirlineListItem[];
    isLoading: boolean;
    setAirlineItems(airlineItems: AirlineListItem[]): void;
}

const defaultAirlineContext: IAirlineContext = {} as IAirlineContext;
export const AirlineContext = createContext<IAirlineContext>(defaultAirlineContext);
